import React from 'react'
import {BookmarkButton, PDFButton, ReturnButton, Arrow, ArrowDrop} from './'
import {ArticleNavStyle} from './../styles'

export default ({slug_bookmark, type, is_bookmark, pdf, next, previous}) => (
  <div className={`${ArticleNavStyle(pdf && pdf.length > 0, previous && next)}`}>
     <ReturnButton />
    { slug_bookmark && <BookmarkButton item={{slug_bookmark: slug_bookmark , type: type}} is_bookmark={is_bookmark} big/> }
    { pdf && (
        <div>
          <PDFButton big pdfs={pdf} />
          <div className="pdf-annotation">
            <Arrow width={24} height={24} />
            <span>
              Click here to download the PDF
            </span>
          </div>
        </div>
      )
    }
    {
      previous && (
        <a href={previous} className="btn btn__arrow btn__arrow--previous">
          <ArrowDrop width={24} height={24} />
        </a>
      )
    }
    {
      next && (
        <a href={next} className="btn btn__arrow btn__arrow--next">
          <ArrowDrop width={24} height={24} />
        </a>
      )
    }
  </div>
)


// WEBPACK FOOTER //
// ./src/components/ArticleNav.js